'use client';

import { COLORS } from '@/constants';
import styled from 'styled-components';

export const ConfigLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 16px;
`;

export const Card = styled.div`
  background: ${COLORS.white};
  border-radius: 10px;
  box-shadow: 0px 3px 6px 0px #7b63571a;
  overflow: hidden;

  & > div + div {
    border-top: 1px solid ${COLORS['neutral/200']};
  }
`;

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 16px 24px;
  border-top: 1px solid ${COLORS['neutral/200']};
`;

export const CardHeader = styled.div<{ $first?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 24px;
  background: ${COLORS['neutral/50']};
  border-left: 3px solid ${COLORS['primary/500']};
  border-top: ${({ $first }) => ($first ? 'none' : `1px solid ${COLORS['neutral/200']}`)};
  cursor: pointer;
`;

export const CardBody = styled.div`
  padding: 4px 24px 8px;
`;

export const SectionLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${COLORS['primary/700']};
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

export const CardTitleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 24px;
  cursor: pointer;
`;

export const CardCollapseBody = styled.div`
  border-top: 1px solid ${COLORS['neutral/200']};
`;

export const CardTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${COLORS['primary/900']};
`;

export const CardSubtitle = styled.div`
  font-size: 14px;
  color: ${COLORS['neutral/400']};
  margin-top: 3px;
`;

export const SectionHint = styled.span`
  font-size: 14px;
  color: ${COLORS['neutral/400']};
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
`;

export const SectionsDivider = styled.div`
  height: 1px;
  background: ${COLORS['neutral/200']};
  margin: 0 24px;
`;

export const ChevronSvg = styled.svg<{ $open: boolean }>`
  transition: transform 0.2s;
  transform: ${({ $open }) => ($open ? 'rotate(0deg)' : 'rotate(-90deg)')};
`;

export const CollapseToggle = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS['primary/700']};
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s ease;

  &:hover {
    background: ${COLORS['primary/50']};
  }

  &:focus-visible {
    outline: 2px solid ${COLORS['primary/500']};
    outline-offset: 2px;
  }
`;

export const SrOnly = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const MemberCodeBadge = styled.code`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-family: 'Fira Code', 'Cascadia Code', monospace;
  color: ${COLORS['primary/700']};
  background: ${COLORS['primary/50']};
  border: 1px solid ${COLORS['primary/200']};
  padding: 3px 10px;
  border-radius: 5px;
`;

export const MemberCodeLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${COLORS['neutral/500']};
  font-family: inherit;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

export const NotChangedBadge = styled.span`
  font-size: 14px;
  color: ${COLORS['neutral/400']};
  font-weight: 400;
`;
